import React, { Component } from 'react';
import {
  ApolloProvider, ApolloClient, HttpLink, InMemoryCache, disableFragmentWarnings
} from '@apollo/client';
import PropTypes from 'prop-types';
import fetch from 'unfetch';
import typeDefs from './typesDefs.graphql';
import resolvers from './resolvers';
import DataProviderContext, { defaultContextValue } from './DataProviderContext';
import { getRelativeAPIPath, dataIdFromObject, typePolicies } from './util';
import possibleTypes from '../shapes/possibleTypes.json';

let client;

disableFragmentWarnings();

const cache = new InMemoryCache({
  possibleTypes,
  dataIdFromObject,
  typePolicies
});

if (typeof window !== 'undefined' && window.__APOLLO_STATE__) {//eslint-disable-line
  cache.restore(window.__APOLLO_STATE__);//eslint-disable-line
}
const DataProviderClient = ({
  children, debug, headers, link, addTypename
}) => {
  const apolloLink = link || new HttpLink({
    uri: getRelativeAPIPath(),
    fetch,
    headers,
  });

  if (typeof addTypename !== 'undefined') {
    cache.addTypename = addTypename;
  }

  client = new ApolloClient({
    cache,
    link: apolloLink,
    connectToDevTools: debug,
    typeDefs,
    resolvers,
  });

  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
};

DataProviderClient.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  debug: PropTypes.bool,
  headers: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  link: PropTypes.any,
  addTypename: PropTypes.bool
};

DataProviderClient.defaultProps = {
  debug: false,
  headers: {},
  link: null,
  addTypename: true
};

export default DataProviderClient;
